import { createContext } from 'react';

export type ScrollLockContextValue = {
  lock: (shouldLock?: boolean) => () => void;
};

export const ScrollLockContext = createContext<ScrollLockContextValue>({
  lock: () => () => null
});
